import { createSlice } from '@reduxjs/toolkit';

interface IQuizState {
    quizes: any;
    quizId: string;
    replyquiz: boolean;
    subject: string;
    questionDataRender: {
        data: any[];
        paging?: any;
    };
    questions: any;
    personasQuizId: string;
    endQuiz: boolean;
}
const initialState: IQuizState = {
    quizes: null,
    quizId: '',
    replyquiz: false,
    subject: '',
    questionDataRender: {
        data: [],
        paging: null,
    },
    questions: null,
    personasQuizId: '',
    endQuiz: false,
};
// Action =====================================================
const quizSlice = createSlice({
    name: 'quiz',
    initialState,
    reducers: {
        setQuizConfig: (state, action) => {
            state.quizes = action.payload.quizes;
        },
        setCurrentQuizId: (state, action) => {
            state.quizId = action.payload;
        },
        setReplyQuiz: (state, action) => {
            state.replyquiz = action.payload;
        },
        setDataQuestion: (state, action) => {
            state.questionDataRender.data = action.payload;
        },
        setQuestion: (state, action) => {
            state.questions = action.payload;
        },
        setPersonasQuizId: (state, action) => {
            state.personasQuizId = action.payload;
        },
        setEndQuiz: (state, action) => {
            state.endQuiz = action.payload;
        },
    },
});

// Selector =====================================================
export const {
    setQuestion,
    setQuizConfig,
    setCurrentQuizId,
    setReplyQuiz,
    setDataQuestion,
    setPersonasQuizId,
    setEndQuiz,
} = quizSlice.actions;
// Reducer=====================================================
const quizReducer = quizSlice.reducer;
export default quizReducer;
